import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CompanySelfOnboardContainer from '@perpay-web/fintech/components/containers/CompanySelfOnboardContainer';

import styles from './CompanySelfOnboardCardSignupMVP.scss';

const CompanySelfOnBoarding = ({
    selfOnboardingInitialValue = '',
    onSubmitSelfOnboardEmployer,
    isMarketplaceSignup = false,
}) => (
    <CompanySelfOnboardContainer
        initialValue={selfOnboardingInitialValue}
        onSubmit={(value) => onSubmitSelfOnboardEmployer(value)}
    >
        {({ canSubmit, renderForm, isLoading }) => (
            <LegacyFocusLayout
                className={styles.container}
                contentClassName={styles.content}
                footerClassName={styles.footer}
                footer={
                    <CardCta
                        action='primary'
                        disabled={!canSubmit}
                        mode={isMarketplaceSignup ? 'primary' : 'dark'}
                        className={
                            isMarketplaceSignup
                                ? styles[
                                      'company-name__footer__continue--marketplace'
                                  ]
                                : styles['company-name__footer__continue']
                        }
                        Component={CustomButton}
                        loading={isLoading}
                        type='submit'
                    >
                        Add my company
                    </CardCta>
                }
            >
                <div className={styles.content__header}>
                    Add your company to Perpay!
                </div>
                <p className={styles['company-name__copy']}>
                    Adding your company will make it easier for you to get up
                    and running with Perpay. It will also make it easier for
                    your coworkers to use Perpay in the future!
                </p>
                {renderForm()}
            </LegacyFocusLayout>
        )}
    </CompanySelfOnboardContainer>
);

export default CompanySelfOnBoarding;
